import { useCallback } from 'react'
import { BestContactTimeOptionsType } from './useData'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'

export function useHandlers() {
  const { setFieldValue } = useFormikContext<IAddOpportunityFormModel>()

  const handelChange = useCallback(
    (value: BestContactTimeOptionsType[] | null) => {
      setFieldValue(
        'preferredTimeOfContact',
        value?.map((row) => row.value),
      )
    },
    [],
  )

  return {
    handelChange,
  }
}
